import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Divider,
  Box,
  Stack
} from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch, useSelector } from "react-redux";
import {
  resetUploadCsvState,
  uploadFileRequest
} from "../../redux/UploadCSV/UploadCsvAction";
import CustomButton from "./FormFields/Button";

const UploadCSVDialog = ({ open, onClose, type }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const dispatch = useDispatch();
  const uploadCsv = useSelector((state) => state.upload);
  const { loading, error, success } = uploadCsv;

  useEffect(() => {
    dispatch(resetUploadCsvState());
  }, []);

  useEffect(() => {
    if (success) {
      toast.success(success?.data?.message, {
        position: "top-center",
        autoClose: 3000,
        onClose: () => {
          dispatch(resetUploadCsvState());
          onClose();
          setSelectedFile(null);
        }
      });
    }
  }, [success]);
  useEffect(() => {
    if (error) {
      toast.error(error, {
        position: "top-center",
        autoClose: 3000,
        onClose: () => {
          dispatch(resetUploadCsvState());
          setUploading(false);
        }
      });
    }
  }, [error]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.type !== "text/csv") {
        toast.error("Invalid file type. Please select a valid CSV file.", {
          position: "top-center",
          autoClose: 3000
        });
        setSelectedFile(null);
      } else if (file.size > 5 * 1024 * 1024) {
        toast.error("File size exceeds 5MB. Please choose a smaller file.", {
          position: "top-center",
          autoClose: 3000
        });
        setSelectedFile(null);
      } else {
        setSelectedFile(file);
      }
    }
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      toast.error("No file selected. Please select a CSV file.", {
        position: "top-center",
        autoClose: 3000
      });
      return;
    }
    setUploading(true);
    await dispatch(uploadFileRequest(selectedFile, type));
  };

  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <DialogTitle>Upload CSV</DialogTitle>
        <DialogContent>
          <Stack spacing={2}>
            <Typography variant="body1">Choose a CSV File to Upload</Typography>
            <Box>
              <input
                type="file"
                accept=".csv"
                onChange={handleFileChange}
                className="upload-input"
                id="csv-upload-input"
              />
              <label htmlFor="csv-upload-input">
                <Button
                  variant="outlined"
                  className="orange-button"
                  component="span"
                  disabled={uploading}
                >
                  {selectedFile ? "Change File" : "Select File"}
                </Button>
              </label>
            </Box>
            {selectedFile && (
              <Typography variant="body2" color="textSecondary">
                Selected File: {selectedFile.name} (
                {(selectedFile.size / 1024).toFixed(2)} KB)
              </Typography>
            )}
            <Divider />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              onClose();
              setSelectedFile(null);
            }}
            className="grey-button"
            variant="contained"
            disabled={uploading}
          >
            Cancel
          </Button>

          <CustomButton
            onClick={handleUpload}
            className="orange-button"
            variant="contained"
            loading={loading}
            text={"Upload"}
          />
        </DialogActions>
      </Dialog>
      <ToastContainer />
    </>
  );
};

export default UploadCSVDialog;
